var map = {
	"./bg-duckhunt.png": 3501,
	"./bird-sprite-1.png": 1905,
	"./bird-sprite-2-old.png": 7162,
	"./bird-sprite-2.png": 6846,
	"./bird-sprite-3.png": 7842,
	"./bird-sprite-super-victor.png": 8936,
	"./bird-sprite-victor.png": 2816,
	"./bullet-icon.png": 5947,
	"./cutscene-bg.png": 228,
	"./detechtiv-holding.png": 5433,
	"./detechtiv.png": 6405,
	"./doggy.png": 3304,
	"./duck-icon-green.png": 7554,
	"./duck-icon-pink.png": 6065,
	"./duck-icon-white.png": 2361,
	"./foreground-mobile.png": 1006,
	"./foreground-sheet.png": 3815,
	"./foreground.png": 2292,
	"./green.jpg": 2412,
	"./hacker.gif": 8551,
	"./hero-bg.png": 3814,
	"./kurre-sprite.png": 9007,
	"./office-2.gif": 6056,
	"./office-bg.png": 1254,
	"./raven.png": 6578,
	"./red.jpg": 4663,
	"./tree-and-bush-sprite.png": 7966,
	"./tree-and-bush.gif": 402,
	"./tree-and-bush.png": 7476,
	"./yellow.jpg": 4039,
	"./z.png": 3578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;